module.exports = __webpack_public_path__ + "img/header.2d51c57c.png";